var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lightbox",rawName:"v-lightbox",value:(_vm.imageSrc),expression:"imageSrc"}],attrs:{"src":_vm.thumbSrc,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }